export default __webpack_public_path__ + "assets/webgl/scene-8.4eaaac97.glb";